import Vue from 'vue';
import Router from 'vue-router';
import sdkAuth from './sdkAuth';

import About from './views/About.vue';
import Home from './components/Home.vue';
import Login from './components/Login.vue';
import Unit from './components/Unit.vue';

import appSettings from './appSettings';

// import unitsShizzle from './components/___units.vue';
// import Units from './components/Units.vue';

const sdkAuthOptions = {
  storageKeyPrefix: appSettings.appStorageKeyPrefix,
  systemID: appSettings.systemID,
  // tokenExpiresAfterMinutes: parseInt(process.env.VUE_APP_TOKEN_EXPIRES_AFTER_MINUTES, 10)
  // These are the defaults, no need to pass them in.
  // storageKeyForRememberMe: 'rememberMe',
  // storageScheme: 'session',  // Removed and put into sdkAuth hardcoded for each piece.
  // storageKeyForScope: 'scope',
  // storageKeyForUserInfo: 'UserInfo',
  // storageKeyForUserName: 'userName',
};

Vue.use(Router);
Vue.use(sdkAuth, sdkAuthOptions);

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/unit',
    name: 'unit',
    component: Unit
  }
  ]
});
